<script>
import infoIcon from '@/assets/images/icons/info.svg?inline'
import checkLargeIcon from '@/assets/images/icons/check-large.svg?inline'
import closeIcon from '@/assets/images/icons/close.svg?inline'

export default {
  name: 'aviaticket-flight-info',
  components: {
    infoIcon,
    checkLargeIcon,
    closeIcon
  },
  props: {
    aviaticketId: {
      type: String,
      required: true
    },
    tarrifId: {
      type: String,
      default: () => null
    },
    wrapperClass: {
      type: String,
      default: () => null
    },
    flightIndex: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    isModalActive: false
  }),
  computed: {
    getFlight() {
      return this.$store.getters['cart/getFlight'](this.flightIndex)
    },
    getFlightRules() {
      return this.$store.getters['cart/getFlightRules']({
        flightIndex: this.flightIndex,
        aviaticketId: this.aviaticketId
      })
    },
    rulesIsLoading() {
      return this.getFlightRules.isLoading
    },
    getFlightTarrifs() {
      const current = this.$store.getters['cart/getFlightTarrifs']({
        flightIndex: this.flightIndex,
        aviaticketId: this.aviaticketId
      }).collection

      return current.length
        ? current.find(tarrif => tarrif.id === this.tarrifId)
        : { name: null, options: [] }
    },
  },
  methods: {
    showModal() {
      this.$store.dispatch('cart/getFlightRules', {
        aviaticketId: this.aviaticketId,
        aviaSearchId: this.getFlight.searchId,
        recommendationId: this.aviaticketId,
        flightIndex: this.flightIndex
      })
      this.isModalActive = true
    },
    hideModal() {
      this.isModalActive = false
    }
  }
}
</script>

<template>
  <div :class="wrapperClass">
    <infoIcon
      fill="#ababab"
      class="cart__penalties--btn cart__aviatickets-flight-info--btn"
      @click="showModal"
    />
    <b-modal
      :active.sync="isModalActive"
      scroll="keep"
      :can-cancel="['escape', 'outside']"
      @close="hideModal"
    >
      <div class="card">
        <div
          class="modal__wrap card-content"
          :class="{ loading: rulesIsLoading }"
        >
          <b-loading
            :is-full-page="false"
            :active="rulesIsLoading"
          />
          <div
            v-if="!rulesIsLoading"
            class="modal__content"
          >
            <div
              v-if="getFlightRules.hasError"
            >
              <h2
                v-for="(error, index) in getFlightRules.errors"
                :key="index"
                class="cart__penalties--error"
              >
                {{ error }}
              </h2>
            </div>
            <div
              v-else
              class="cart__aviatickets-flight-info--data"
            >
              <div class="modal__header">
                <h2>Правила перелёта </h2>
                <close-icon
                  @click="hideModal"
                />
              </div>
              <div class="modal__content-item">
                <h2
                  v-if="getFlightTarrifs.options.length"
                >
                  Тариф для всех перелётов: {{ getFlightTarrifs.name }}
                </h2>
                <div class="cart__aviatickets-flight-info--options-row">
                  <div
                    v-for="(option, index) in getFlightTarrifs.options"
                    :key="index"
                    class="cart__aviatickets-flight-info--option"
                  >
                    <checkLargeIcon />
                    <span>{{ option }}</span>
                  </div>
                </div>
                <div
                  v-for="(rule, index) in getFlightRules.collection"
                  :key="index"
                  class="cart__aviatickets-flight-info--rules"
                >
                  <h2>
                    {{ rule.departure.cityName }}
                    <span
                      v-if="rule.departure.airportName"
                    >
                      , аэропорт {{ rule.departure.airportName }}
                    </span>
                    -
                    {{ rule.arrival.cityName }}
                    <span
                      v-if="rule.arrival.airportName"
                    >
                      , аэропорт {{ rule.arrival.airportName }}
                    </span>
                  </h2>
                  <div>
                    <p>
                      {{ rule.description }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>